import React from "react";


export const ResearchSection = () => {
    return (
        <>
            <div className={'ibox'}>
                <div className="ibox-title">
                    <b>
                        <a target="_blank"
                           href="https://jbiomedsem.biomedcentral.com/articles/10.1186/s13326-016-0111-z"
                           rel='noopener noreferrer'>Consolidating
                            Drug Data on a Global Scale Using Linked Data</a>
                    </b>.
                </div>
                <div className="ibox-content">
                    Milos Jovanovik, Dimitar Trajanov. Journal of Biomedical Semantics 8:3, 2017.
                    [<a target="_blank"
                        href="https://jbiomedsem.biomedcentral.com/articles/10.1186/s13326-016-0111-z"
                        rel='noopener noreferrer'>JBiomedSem</a>]
                    [<a target="_blank" href="https://www.researchgate.net/publication/312583566"
                        rel='noopener noreferrer'>Research-Gate</a>]
                </div>
            </div>

            <div className="ibox">
                <div className="ibox-title">
                    <b>
                        <a target="_blank" href="https://mjovanovik.com/publications/MJ-PhD-Executive-Summary-v2.10.pdf"
                           rel='noopener noreferrer'>Linked
                            Data Application Development Methodology</a>
                    </b>.
                </div>
                <div className="ibox-content">
                    Milos Jovanovik, PhD Thesis. Faculty of Computer Science and Engineering, Ss. Cyril and Methodius
                    University
                    in Skopje, Macedonia, November 2016.
                    [<a target="_blank" href="http://hdl.handle.net/20.500.12188/253" rel='noopener noreferrer'>UKIM</a>]
                    [<a target="_blank" href="https://www.researchgate.net/publication/313057939"
                        rel='noopener noreferrer'>ResearchGate</a>]
                </div>
            </div>

            <div className="ibox">
                <div className="ibox-title">
                    <b>
                        <a target="_blank" href="https://www.researchgate.net/publication/265299863"
                           rel='noopener noreferrer'>Linked
                            Music Data from
                            Global Music Charts</a>
                    </b>.
                </div>
                <div className="ibox-content">
                    Milos Jovanovik, Matej Petrov, Bojan Najdenov, Dimitar Trajanov. 10th International Conference on
                    Semantic
                    Systems (SEMANTiCS 2014), pp. 108-115, Leipzig, Germany, 2014.
                    [<a target="_blank" href="https://dl.acm.org/citation.cfm?doid=2660517.2660536"
                        rel='noopener noreferrer'>ACM
                    DL</a>]
                    [<a target="_blank" href="https://www.researchgate.net/publication/265299863"
                        rel='noopener noreferrer'>ResearchGate</a>]
                </div>
            </div>

            <div className="ibox">
                <div className="ibox-title">
                    <b>
                        <a target="_blank" href="https://www.researchgate.net/publication/236273564"
                           rel='noopener noreferrer'>Linked
                            Open Drug Data from
                            the Health Insurance Fund of Macedonia</a>
                    </b>.
                </div>
                <div className="ibox-content">
                    Milos Jovanovik, Bojan Najdenov, Dimitar Trajanov. 10th International Conference for Informatics and
                    Information Technology, pp. 56-61, 2013.
                    [<a target="_blank" href="http://ciit.finki.ukim.mk/data/ViewPageArchive.html?year=2013"
                        rel='noopener noreferrer'>CIIT</a>]
                    [<a target="_blank" href="https://www.researchgate.net/publication/236273564"
                        rel='noopener noreferrer'>ResearchGate</a>]
                </div>
            </div>

        </>
    )
}
